import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { ReactComponent as CheckIcon } from '../../../../../assets/images/icons/check.svg';
import Button from '../../../../../components/Button';
import WebViewAppBar from '../../../../../components/WebViewAppBar/WebViewAppBar';
import HideChatWidget from '../../../../../components/ZendeskChat/HideChatWidget';
import * as events from '../../../../../lib/analytics/events';
import styles from './CancelConfirmation.module.scss';
import { DateTime } from 'luxon';
import { HideCookieConsentBanner } from '../../../../../lib/oneTrust';

interface CancelConfirmationState {
  nextBillDate: string;
}

export default function CancelConfirmation() {
  const { t } = useTranslation();
  const location = useLocation<CancelConfirmationState>();
  const nextBillDate = location.state?.nextBillDate ?? null;
  const onClose = useCallback(() => {
    events.airvetManagement.cancellation.successClose();
    window.open('fi://closeappview');
  }, []);

  return (
    <>
      <div className={styles.confirmationContainer}>
        <WebViewAppBar />
        <div className={styles.section}>
          <div className={styles.checkIcon}>
            <CheckIcon width="64px" height="64px" />
          </div>
          <h2>{t('airvet_membership_canceled')}</h2>
          <p>
            {t('you_will_no_longer_be_charged_for_airvet_access_beginning_on_date', {
              date: DateTime.fromISO(nextBillDate).toFormat('LLLL d, yyyy'),
            })}
          </p>
        </div>
        <div className={styles.actions}>
          <Button onClick={onClose}>{t('close')}</Button>
          <div className={styles.buttonSpacer} />
        </div>
        <HideChatWidget />
        <HideCookieConsentBanner />
      </div>
    </>
  );
}
